/* angular:styles/component:css;891ef954f2261a18c8bf5b7f4c37adf2b364b2e4530ad00ca4bbbeb3ad5874cf;/home/vsts/work/1/s/src/app/components/payroll/timesheets/mass-adjustments/mass-adjustments.component.ts */
.table-style {
  width: 100%;
}
.custom-row-actions {
  display: flex;
  width: 100%;
}
.custom-row-actions__container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}
/*# sourceMappingURL=mass-adjustments.component-CO4M5BTD.css.map */
